import { PickListItemInterface } from 'v2/modules/picklist/interfaces/picklist.interface';
import { ILocation } from '../../location/interfaces/location.interface';
import { ILot } from '../../lot';
import { CommonStatusEnum } from '../../shared/interfaces/common.interface';
import { IUnitOfMeasure } from '../../unit-of-measure/interfaces/unit-of-measure.interface';

export interface IRfq {
  id :number;
  addedBy :number;
  businessAccountId :number;
  productName :string;
  productDescription :string;
  unitsQtyAnnual :number;
  unitsQtyFirst :number;
  targetPrice :number;
  productCategoryId :number;
  productCategory ?:string;
  willPurchaseSample :number;
  isProductInMarket :number;
  productLink :any;
  destinationAddress :string;
  destinationCity :string;
  destinationState :string;
  destinationZip :string;
  hasPrototype :number;
  hasPackingReq :number;
  otherDetails :string;
  quotationsCount :number;
  photo :string;
  status :number;
  purchaseOrderDt :string;
  sampleOrderDt :string;

  unitsQtyAnnualType :number;
  addressNotKnown :number;
  changesToMake :string;
  developmentStatus :string;
  unitsQtyMoq :number;
  brandProduct :number;
  artworkAvailable :number;
  productHasVariants :number;
  productVariants :any;

  prLabelingStickers :number;
  prCustomPrinting :number;
  prBundling :number;
  prVariousPrep :number;
  prCartonArrangement :number;
  prSameAsLink :number;
  prGenericQuote :number;

  prLabelingStickersText :string;
  prCustomPrintingText :string;
  prBundlingText :string;
  prVariousPrepText :string;
  prCartonArrangementText :string;
  prGenericQuoteText :string;

  odSampleToMatch :number;
  odSoldOnAmazon :number;
  odProProductPictures :number;
  odNeedHelpInPrototype :number;
  odNeedGraphicDesign :number;
  odSpecialCertificates :number;
  odInfoDetails :string;

  productTypeId :number;
  productType :string;

  internalSku :string;
  productDeptId :number;
  preferredVendorId :number;

  shippingWeight :any;
  dimensionalWeight :any;
  productWeight :any;
  cartonWeight :any;
  boxWeight :any;
  palletWeight :any;

  materials :any;
  customFields :any;
  packageCost :number;
  laborCost :number;

  rfqAttachments ?:RfqAttachment[];
  userAccount ?:any;
  admins ?:any;
  members ?:any;
  locations ?:any;
  variantSkus ?:any;
  variantParentId ?:number;
  basePrice ?:any;
  stock ?:RfqStock;
  isDiscontinued :any;
  variantSkusCount :any;
  lotTracking :boolean;

  unitClassId :number;
  type :string;
  unitOfMeasures ?:IUnitOfMeasure[];
  defaultPurchaseUnitId :number;
  defaultSellingUnitId :number;
  defaultSellingUnit ?:IUnitOfMeasure;
  discountStructure ?:any;
  isKit :boolean;
  markupStructure ?:any;
  ossLimitNotify :any;
  qtyAvailable :number;
  retailPrice :number;
  sellable ?:boolean;
  subCategoryId :number;
  unitPrice :number;
  variantParent ?:IRfq;
  totalVariantSkus ?:number;
  quotations ?:any;
  picklistItems ?:PickListItemInterface[];
}

export interface RfqStockLocationInterface {
  id :number;
  createdAt :Date;
  updatedAt :Date;
  status :CommonStatusEnum;
  rfqStockId :number;
  locationId :number;
  onHandQuantity :number;
  reservedQuantity :number;
  lotId :number;
  rfqId :number;
  lot ?:ILot;
  rfqStock ?:RfqStock;
}

export interface IRfqStock {
  id :number;
  rfq_id :number;
  qty_onhand :number;
  qty_pending :number;
  qty_incoming :number;
  last_updated :Date;
}

export interface RfqAttachment {
  id :number;
  rfq_id :number;
  filename :string;
  filetype :string;
  fileurl :string;
  thumburl :string;
  remarks ?:string;
}

export interface RfqStock {
  id :number;
  availableQuantity :number;
  onHandQuantity :number;
  onHoldQuantity :number;
  pendingQuantity :number;
  createdAt :Date;
  inStockQuantity :number;
  inboundQuantity :number;
  lastQuantitySync :number;
  incomingQuantity :number;
  locationId :number;
  pickedQuantity :number;
  rfq_id :number;
  sku :string;
  status :string;
  totalFbaQuantity :number;
  transferQuantity :number;
  updatedAt :Date;
  warehouseId :number;
}

export interface ICategory {
  id :number;
  created_at :Date;
  deleted_at :Date;
  updated_at :Date;
  description :string;
  discount_structure :IDiscountStructrure;
  markup_structure :IDiscountStructrure;
  product_category :string;
  status :number;
  sub_categories :ISubCategory[];
}

export interface ISubCategory {
  id :number;
  created_at :Date;
  deleted_at :Date;
  updated_at :Date;
  description :string;
  discount_structure :IDiscountStructrure;
  markup_structure :IDiscountStructrure;
  status :number;
  category_id :number;
  sub_category :string;
}

export interface IDiscountStructrure {
  discount :number;
  label :string;
  min :number;
  max :number;
}

export interface IRfqStockLog {
  id :number;
  quantity :number;
  action :string;
  transaction :string;
  transactionId :number;
  runningQuantityBalance :number;
  lotRunningBalance :number;
  lotId :number;
  rfqLot :ILot;
  locationId :number;
  location :ILocation;
}

export interface IRfqVariantInterface {
  internal_sku :string;
  parent_sku :any;
  product_name :string;
  retail_price :number;
  variant_parent_id :number;
  wholesale_price :number;
  id :number;
}

export enum EProductTypes {
  PRODUCT = 'PRODUCT',
  KIT = 'KIT',
  SKU = 'SKU',
}

export enum ERfqTypes {
  KIT = 'kit',
  SKU = 'sku',
}

export enum ERfqStatus {
  AVAILABLE = 'Available',
  UNAVAILABLE = 'Unavailable',
}

export interface IRfqProductSubstitution {
  priority :number;
  substituteProduct :IRfq;
  substituteProductId :number;
  product ?:IRfq;
  productId ?:number;
  id ?:number | null;
}

export interface IRfqOld {
  id :number;
  sku :string;
  product_name :string;
}
